export let radiosUrl=[
    {
        nombre:"Radio FM",
        url:"https://radio.yoemito.net/listen/centrofm/stream",
        volumen:0.9
    },
    {
        nombre:"Radio AM",
        url:"https://radio.yoemito.net/listen/centroam/stream",
        volumen:0.9
    },
    {
        nombre:"Radio Universal",
        url:"https://radio.yoemito.net/listen/universalfm/stream",
        volumen:0.9
    }
]
    


